<template>
    <div class="row">
        <div class="col-md-12">
            <div class="content-tool-title">
                <p> Tokyo 2020</p>
            </div>
            <div class="content-tool">
                <div class="content-tool-color">
                    <ul>
                        <li @click="findType('All','-1')"><p class="shape-1 type-bg-1-new" :class="(activeNumber == 'All') ? 'bgImage1': ''"></p><p>Бүх гүйлгээ</p></li>
                        <li @click="findType('StoreManagement',1)"><p class="shape-2 type-bg-2-new" :class="(activeNumber == 'StoreManagement') ? 'bgImage': ''"></p><p>Хамтран эзэмшигч</p></li>
                    </ul>
                </div>
                <div class="content-tool-tool" style="flex:3">
                    <form action="" @submit.prevent="findDate">
                        <div class="form-group" style="position:relative">
                            <datetime type="date" v-model="Startdate"  ref="dateTimePicker1" format="yyyy-MM-dd" placeholder="эхлэх огноо"></datetime>
                            <span class="icon-date" @click="$refs.dateTimePicker1.isOpen = true"><i class="fas fa-calendar-alt"></i></span>
                        </div>
                        <div class="form-group" style="position:relative">
                            <datetime type="date" v-model="Enddate"  ref="dateTimePicker2"  format="yyyy-MM-dd" placeholder="дуусах огноо"></datetime>
                            <span class="icon-date" @click="$refs.dateTimePicker2.isOpen = true"><i class="fas fa-calendar-alt"></i></span>
                        </div>
                        <input type="submit" class="dashboard-btn" value="Шүүх">
                    </form>
                </div>
            </div>    
        </div>
    </div>
</template>

<script>
import { Datetime } from 'vue-datetime'


    export default {
        data(){
            return{
                Startdate:'',
                Enddate: '',
                activeNumber:'All',
            }
        },
        methods:{
            //find date filter
            findDate(){
                this.$emit('dateFilter',this.Startdate,this.Enddate);
            },
            //find type
            findType(value,partner){
                this.activeNumber = value;
                this.$emit('filterType',value,partner);
            },
        },
        components:{
            Datetime
        },

    }
</script>
<style>
.bgImage{
    background-image:url('../../assets/icon/active-icon.png')!important;
}
.bgImage1{
    background-image:url('../../assets/icon/active-icon-black.png')!important;
}
</style>
